<template>
  <el-menu default-active="1" mode="horizontal" background-color="#324157" text-color="#fff" active-text-color="#ffd04b">

    <el-menu-item index="99">Ustawienia</el-menu-item>
    <el-menu-item index="1" @click="goToPage('/ustawienia/stada')">Stada</el-menu-item>
    <el-menu-item index="3" @click="goToPage('/ustawienia/aplikacji')">Aplikacji</el-menu-item>
    <el-menu-item index="5" @click="goToPage('/ustawienia/kopii-zapasowej')">Kopii zapasowej</el-menu-item>

    <el-menu-item index="4" style="float: right;" @click="goToMainPage">Stado</el-menu-item>
  </el-menu>
</template>
<script>
import router from "../router/settings-router";

export default {
  methods: {
    goToMainPage() {
      window.location = "/";
    },
    goToPage(page) {
      router.push(page);
    }
  }
};
</script>

<style>

</style>
